import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "flex-container" }
const _hoisted_2 = { class: "inline-flex background-white justify-content-space-between align-items-center title-container" }
const _hoisted_3 = { class: "display-flex align-items-center" }
const _hoisted_4 = { class: "font-weight-600 font-size-24" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "position-relative" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "flex-container"
}
const _hoisted_9 = { class: "no-item-parent-div text-center empty-container" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "no-item-message-container text-center" }
const _hoisted_12 = { class: "grey-text" }
const _hoisted_13 = { class: "grey-text" }
const _hoisted_14 = {
  key: 1,
  class: "flex-container content-container overflow-auto email-listings-overflow"
}
const _hoisted_15 = { class: "div-theme-block border-radius-10 hide-scroll" }
const _hoisted_16 = { class: "display-flex justify-content-space-between table-border" }
const _hoisted_17 = { class: "font-weight-600 font-size-16" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["src"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["src"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "domain-table-content" }
const _hoisted_25 = {
  key: 0,
  class: "margin-top-15 info-block"
}
const _hoisted_26 = { class: "font-weight-400 font-size-14 blue-text-color" }
const _hoisted_27 = {
  key: 1,
  class: "margin-top-15"
}
const _hoisted_28 = { class: "item-listing padding-10 overflow-auto email-listings-overflow" }
const _hoisted_29 = { class: "itemsDiv" }
const _hoisted_30 = { class: "email-listings-table-header bold-text" }
const _hoisted_31 = { class: "email-listings-table-column display-inline-flex width15 margin-left-20" }
const _hoisted_32 = { class: "email-listings-table-column display-inline-flex width30" }
const _hoisted_33 = { class: "email-listings-table-column display-inline-flex width30" }
const _hoisted_34 = { class: "email-listings-table-column" }
const _hoisted_35 = { class: "item-saparator div-program" }
const _hoisted_36 = { class: "dns-records-row inline-flex100" }
const _hoisted_37 = { class: "width15 display-flex align-items-center margin-left-4" }
const _hoisted_38 = { class: "width35 display-flex align-items-center domain-listings-row margin-left-10" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["src"]
const _hoisted_41 = { class: "email-listings-sender width35 display-flex align-items-center domain-listings-row" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["src"]
const _hoisted_44 = { class: "margin-left-14 width25 display-flex align-items-center" }
const _hoisted_45 = {
  key: 0,
  class: "margin-top-10"
}
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "font-weight-600 font-size-14 margin-left-10" }
const _hoisted_48 = {
  key: 2,
  class: "flex-container content-container"
}
const _hoisted_49 = { class: "width100" }
const _hoisted_50 = { class: "font-size-14 font-weight-400 label-text" }
const _hoisted_51 = { class: "color-red" }
const _hoisted_52 = ["maxlength", "placeholder"]
const _hoisted_53 = {
  key: 3,
  class: "flex-container content-container"
}
const _hoisted_54 = { class: "width100 display-flex align-items-center" }
const _hoisted_55 = { class: "input-container margin-right-20" }
const _hoisted_56 = { class: "font-size-14 font-weight-400 label-text" }
const _hoisted_57 = { class: "color-red" }
const _hoisted_58 = ["maxlength", "placeholder", "readonly"]
const _hoisted_59 = { class: "margin-right-20" }
const _hoisted_60 = ["src"]
const _hoisted_61 = { class: "input-container" }
const _hoisted_62 = { class: "font-size-14 font-weight-400 label-text" }
const _hoisted_63 = { class: "width100 margin-top-20" }
const _hoisted_64 = { class: "font-size-14 font-weight-400 label-text" }
const _hoisted_65 = { class: "color-red" }
const _hoisted_66 = ["placeholder"]
const _hoisted_67 = {
  key: 4,
  class: "footer-tab"
}
const _hoisted_68 = { class: "parent-div-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ValidationSummary = _resolveComponent("ValidationSummary")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.headerText), 1),
        (_ctx.showAddDomainScreen || _ctx.showEmailDomainsTable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, [
                _createElementVNode("i", {
                  class: "fa fa-info-circle overlay-info margin-left-8",
                  "aria-hidden": "true",
                  onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.GetInformationString(true, _ctx.domainInfoString))),
                  onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.GetInformationString(false, _ctx.domainInfoString)))
                }, null, 32),
                _withDirectives(_createElementVNode("div", { class: "information-icon-div" }, _toDisplayString(_ctx.GetDomainTooltipText()), 513), [
                  [_vShow, _ctx.isDomainTooltipVisible]
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("a", {
          href: "javascript:void(0)",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.Close()))
        }, [
          _createElementVNode("img", { src: _ctx.crossIcon }, null, 8, _hoisted_7)
        ])
      ])
    ]),
    (_ctx.showNoDomainAddedScreen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("img", {
                src: _ctx.localSelectedType === _ctx.DrawerType.DomainDrawer ? _ctx.globeIcon : _ctx.emailIcon
              }, null, 8, _hoisted_10)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("OrgSettings.EmailBranding.NoDomainAddedText")), 1),
              _createElementVNode("div", null, [
                _createElementVNode("span", {
                  class: "add-hyperlink",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.HandleAddDomain && _ctx.HandleAddDomain(...args)))
                }, _toDisplayString(_ctx.$t("OrgSettings.EmailBranding.AddDomainTextLine1")), 1),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("OrgSettings.EmailBranding.AddDomainSubTextLine2")), 1)
              ])
            ])
          ])
        ]))
      : (_ctx.showDomainRecordsTable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dnsRecordsTableData.Domains, (domain) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: domain.Id
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", null, [
                        _createElementVNode("label", _hoisted_17, _toDisplayString(domain.DomainName), 1),
                        _createElementVNode("span", {
                          class: _normalizeClass([_ctx.GetDomainStatusCssClass(domain.OverallDomainStatus), "margin-left-10"])
                        }, _toDisplayString(_ctx.SetOverallDomainStatus(domain.OverallDomainStatus)), 3)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("button", {
                          class: "button-style",
                          onClick: ($event: any) => (_ctx.HandleCopyClick(domain.DomainName))
                        }, [
                          _createElementVNode("img", {
                            src: _ctx.copiedValue === domain.DomainName ? _ctx.greenTickIcon : _ctx.copyIcon
                          }, null, 8, _hoisted_19)
                        ], 8, _hoisted_18),
                        _createElementVNode("button", {
                          class: "button-style",
                          onClick: ($event: any) => (_ctx.DeleteDomainData(domain.Id))
                        }, [
                          _createElementVNode("img", {
                            src: _ctx.deleteIcon,
                            class: "margin-left-10"
                          }, null, 8, _hoisted_21)
                        ], 8, _hoisted_20),
                        _createElementVNode("button", {
                          class: "button-style",
                          onClick: ($event: any) => (_ctx.VerifyDomainStatus(domain.Id, domain.DomainName))
                        }, [
                          _createElementVNode("img", {
                            src: _ctx.refreshIcon,
                            class: "margin-left-10"
                          }, null, 8, _hoisted_23)
                        ], 8, _hoisted_22)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      (domain.OverallDomainStatus === _ctx.DomainStatus.Pending)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("OrgSettings.EmailBranding.DomainVerificationInformationMessage")), 1)
                          ]))
                        : (domain.OverallDomainStatus === _ctx.DomainStatus.Broken)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              (_ctx.isValidationSummaryVisible)
                                ? (_openBlock(), _createBlock(_component_ValidationSummary, {
                                    key: 0,
                                    "error-fields": _ctx.validationErrorFields,
                                    "validation-summary-heading": _ctx.validationSummaryHeading,
                                    onCloseClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.CloseValidationSummary($event)))
                                  }, null, 8, ["error-fields", "validation-summary-heading"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("Type")), 1),
                            _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t("Name")), 1),
                            _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t("Value")), 1),
                            _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t("OrgSettings.EmailBranding.Status")), 1)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([
                      domain.DnsRecords.Spf,
                      domain.DnsRecords.Dkim1,
                      domain.DnsRecords.Dkim2,
                      domain.DnsRecords.Dmarc
                    ], (dnsRecord, index) => {
                            return (_openBlock(), _createElementBlock("div", { key: index }, [
                              _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("div", _hoisted_36, [
                                  _createElementVNode("div", _hoisted_37, _toDisplayString(dnsRecord.RecordType), 1),
                                  _createElementVNode("div", _hoisted_38, [
                                    _createTextVNode(_toDisplayString(dnsRecord.HostName) + " ", 1),
                                    _createElementVNode("button", {
                                      class: "button-style button-effects copy-button",
                                      onClick: ($event: any) => (_ctx.HandleCopyClick(dnsRecord.HostName))
                                    }, [
                                      _createElementVNode("img", {
                                        src: _ctx.copiedValue === dnsRecord?.HostName ? _ctx.greenTickIcon : _ctx.copyIcon
                                      }, null, 8, _hoisted_40)
                                    ], 8, _hoisted_39)
                                  ]),
                                  _createElementVNode("div", _hoisted_41, [
                                    _createTextVNode(_toDisplayString(dnsRecord.HostData) + " ", 1),
                                    _createElementVNode("button", {
                                      class: "button-style button-effects copy-button",
                                      onClick: ($event: any) => (_ctx.HandleCopyClick(dnsRecord.HostData))
                                    }, [
                                      _createElementVNode("img", {
                                        src: _ctx.copiedValue === dnsRecord.HostData ? _ctx.greenTickIcon : _ctx.copyIcon
                                      }, null, 8, _hoisted_43)
                                    ], 8, _hoisted_42)
                                  ]),
                                  _createElementVNode("div", _hoisted_44, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(_ctx.GetRecordStatusCssClass(dnsRecord.IsValid, domain.OverallDomainStatus))
                                    }, _toDisplayString(_ctx.SetDomainStatus(dnsRecord.IsValid, domain.OverallDomainStatus)), 3)
                                  ])
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]),
                  (domain.OverallDomainStatus !== _ctx.DomainStatus.Broken)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _createElementVNode("img", {
                          src: domain.OverallDomainStatus === _ctx.DomainStatus.Pending ? _ctx.infoIcon : _ctx.successStatusIcon
                        }, null, 8, _hoisted_46),
                        _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.SetDomainStatusText(domain.OverallDomainStatus)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]))
        : (_ctx.showAddDomainNameScreen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
              _createElementVNode("div", null, [
                (_ctx.isValidationSummaryVisible)
                  ? (_openBlock(), _createBlock(_component_ValidationSummary, {
                      key: 0,
                      "error-fields": _ctx.validationErrorFields,
                      onCloseClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.CloseValidationSummary($event)))
                    }, null, 8, ["error-fields"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("label", _hoisted_50, [
                  _createTextVNode(_toDisplayString(_ctx.$t("OrgSettings.EmailBranding.DomainName")), 1),
                  _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.$t("Asteric")), 1)
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.domainName.$model) = $event)),
                  type: "text",
                  class: "form-control",
                  maxlength: _ctx.domainNameMaxLength,
                  placeholder: _ctx.SetPlaceholderText(),
                  onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.domainName.$model = _ctx.ConvertDomainNameToLowerCase($event.target.value)))
                }, null, 40, _hoisted_52), [
                  [
                    _vModelText,
                    _ctx.v$.domainName.$model,
                    void 0,
                    { trim: true }
                  ]
                ])
              ])
            ]))
          : (_ctx.showAddEmailSection)
            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                _createElementVNode("div", null, [
                  (_ctx.isValidationSummaryVisible)
                    ? (_openBlock(), _createBlock(_component_ValidationSummary, {
                        key: 0,
                        "error-fields": _ctx.validationErrorFields,
                        onCloseClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.CloseValidationSummary($event)))
                      }, null, 8, ["error-fields"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("label", _hoisted_56, [
                      _createTextVNode(_toDisplayString(_ctx.$t("OrgSettings.EmailBranding.EmailPrefix")), 1),
                      _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.$t("Asteric")), 1)
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.v$.emailPrefix.$model) = $event)),
                      type: "text",
                      class: "form-control",
                      maxlength: _ctx.emailPrefixMaxLength,
                      placeholder: _ctx.$t('OrgSettings.EmailBranding.EmailPrefixInputPlaceholder'),
                      readonly: _ctx.selectedDomianId === 0
                    }, null, 8, _hoisted_58), [
                      [
                        _vModelText,
                        _ctx.v$.emailPrefix.$model,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("img", { src: _ctx.atTheRateIcon }, null, 8, _hoisted_60)
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.$t("OrgSettings.EmailBranding.Domain")), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.v$.domainName.$model) = $event)),
                      type: "text",
                      class: "form-control",
                      readonly: ""
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.v$.domainName.$model,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("label", _hoisted_64, [
                    _createTextVNode(_toDisplayString(_ctx.$t("OrgSettings.EmailBranding.SendersName")), 1),
                    _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.$t("Asteric")), 1)
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.v$.senderName.$model) = $event)),
                    type: "text",
                    class: "form-control",
                    placeholder: _ctx.$t('OrgSettings.EmailBranding.SenderNameInputPlaceholder')
                  }, null, 8, _hoisted_66), [
                    [
                      _vModelText,
                      _ctx.v$.senderName.$model,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
    (_ctx.showFooterTab)
      ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "display-flex" }, [
            _createElementVNode("div", { class: "width100" }, [
              _createElementVNode("hr", { class: "footer-hr margin-top-0" })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "btn btn-size-header-large btn-secondary button-width",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.Close()))
              }, _toDisplayString(_ctx.$t("Button.Close")), 1)
            ]),
            _createElementVNode("div", null, [
              (_ctx.localSelectedType === _ctx.DrawerType.EmailDrawer || _ctx.selectedDomianId === 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-size-header-large btn-primary margin-left-20 button-width",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.AddEmailAddress(_ctx.v$)))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("SaveButton")), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showAddDomainButton)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-size-header-large btn-primary margin-left-20 button-width",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.CreateDomain(_ctx.v$)))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("Button.Add")), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}